module.exports = __webpack_public_path__ + "static/media/paper-landscape.a255d6f5.svg";